import createAction from 'loankeeper-common/helpers/createAction'
import { actions } from './constants'

export const openMenu = (options, name) => createAction(actions.OPEN_MENU, { options }, { name })

export const closeMenu = (name) => createAction(actions.CLOSE_MENU, null, { name })
